import React, {Component} from "react";

export default class RepoFiles extends Component {
    render() {

        return (
            <>
                Repo Files
            </>
        );
    }
}